import { render, staticRenderFns } from "./BarPayment.vue?vue&type=template&id=1176f036"
import script from "./BarPayment.vue?vue&type=script&lang=js"
export * from "./BarPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports